import { lazy } from "react";
import { ALLOWED_MODULES } from "../../../constants/enums";
import Loadable from "../../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../../router/AuthorizedRoute";
import { COMPLAINT_REPORT_ASSIGN_ROUTE } from "../../ComplaintReport/CustomerReportConstant";

const OpenComplaints = Loadable(
    lazy(() =>
        import("./OpenComplaints").then(({ OpenComplaints }) => ({
            default: OpenComplaints,
        }))
    )
);

export const complaintsRoutes = [
    {
        path: COMPLAINT_REPORT_ASSIGN_ROUTE,
        exact: true,
        element: (
            <AuthorizedRoute
                allowFullAccess={true}
                moduleIds={[ALLOWED_MODULES.COMPLAINT_REPORT, ALLOWED_MODULES.COMPLAINTS]}
            >
                <OpenComplaints />
            </AuthorizedRoute>
        ),
    },
];
